import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import validator from 'validator';

export const Md5Validator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (validator.isMD5(value)) {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
